'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pkg = require('pkg/tiny-emitter/index');
exports.default = pkg;